<template>
  <div class="room-waiting-list-component">
    <ul class="room-waiting-list">
      <li v-for="(user, i) in waitingList" :key="i" class="room-waiting-item">
        <div class="room-waiting-item-form">
          <p class="room-waiting-item-title">{{ $t("common.number") }}</p>
          <p class="room-waiting-item-value">{{ i + 1 }}</p>
        </div>
        <div class="room-waiting-item-form">
          <p class="room-waiting-item-title">{{ $t("common.name") }}</p>
          <p class="room-waiting-item-value">{{ user.nickName || user.username }}</p>
        </div>
        <div class="room-waiting-item-form">
          <p class="room-waiting-item-title">{{ $t("waitingRoom.join.time") }}</p>
          <p class="room-waiting-item-value">{{ getDateForm(user.joinDate) }}</p>
        </div>
        <div class="room-waiting-item-form">
          <p class="room-waiting-item-title">{{ $t("common.device.camera") }}</p>
          <p class="room-waiting-item-value" :class="[user.cameraStatus === 'on' ? 'success' : 'error']">{{ deviceStatus(user.cameraStatus) }}</p>
        </div>
        <div class="room-waiting-item-form">
          <p class="room-waiting-item-title">{{ $t("common.device.mic") }}</p>
          <p class="room-waiting-item-value" :class="[user.micStatus === 'on' ? 'success' : 'error']">{{ deviceStatus(user.micStatus) }}</p>
        </div>
        <div class="room-waiting-item-form">
          <p class="room-waiting-item-title">{{ $t("setting.join.role.title") }}</p>
          <div class="room-waiting-item-value">
            <GrmSelect fullWidth white :options="userRoleOptions" @input="(roleId) => changeUserRole(user, roleId)" />
          </div>
        </div>
        <div class="room-waiting-item-form">
          <p class="room-waiting-item-title">{{ $t("deviceSetting.preview.join.request") }}</p>
          <div class="room-waiting-item-value">
            <VButton small class="room-waiting-item-btn" @click="approveApi({ roomId: room.roomId, userId: user.userId, roleId: user.joinRoleId })">{{ $t("common.apply") }}</VButton>
            <VButton small cancel class="room-waiting-item-btn" @click="disapproveApi({ roomId: room.roomId, userId:user.userId, roleId: user.joinRoleId })">{{ $t("common.reject") }}</VButton>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import moment from "moment";

import { roomEventApi } from "@/core/api/room.event.api";

import GrmSelect from '@/components/Common/select/GrmSelect.vue'
import VButton from '@/components/Common/VButton'

export default {
  name: 'RoomWaitingList',
  components: {
    GrmSelect,
    VButton
  },
  data() {
    const events = {
      waiting_room_approved: e => {
        this.APPROVAL(e.data.userId);
        if(this.waitingList.length <= 0) {
          this.SET_UNCHECKED(false)
        }
      },
      waiting_room_disapproved: e => {
        this.APPROVAL(e.data.userId);
        if(this.waitingList.length <= 0) {
          this.SET_UNCHECKED(false)
        }
      },
      waiting_room_left: e => {
        this.APPROVAL(e.userId);
        if(this.waitingList.length <= 0) {
          this.SET_UNCHECKED(false)
        }
      },
      waiting_room_noDevicePermission: e => {
        if (this.userId === e.userId) { // XXX 서버에서 대상을 찾아서 보내면 더 좋다.
          this.NO_PERMISSION();
        }
      },
      waiting_room_joined: e => {
        const user = { ...e.data.user, joinRoleId: this.defaultRoleId }

        this.ADD_WAITING_USER(user);
        if(!this.$isModalShown('RoomWaitingModalMobile')) {
          this.SET_UNCHECKED(true)
        }
      },
      waiting_room_disabled: e => {
        console.log('waiting_room_disabled')
      },
    }

    const userRoleOptions = [
      { value: 'emcee',  title: this.$t('common.emcee') },
      { value: 'participant',  title: this.$t('common.participant'),  selected: true },
    ]

    return {
      events,
      userRoleOptions,
      defaultRoleId: 'participant'
    }
  },
  computed: {
    ...mapGetters('room', [
        'room'
    ]),
    ...mapState('waitingRoom', [
        'waitingList'
      ]
    ),
    deviceStatus: function() {
      return (status) => {
        return status === 'on' ? this.$t('common.normal') : this.$t('common.error');
      }
    },
    getDateForm: function() {
      return (date) => {
        return moment(date).format('YYYY-MM-DD HH:mm:ss');
      }
    },
  },
  created() {
    roomEventApi.addEventListeners(this.events, this);
  },
  destroyed() {
    roomEventApi.removeEventListeners(this.events);
  },
  methods: {
    ...mapActions('waitingRoom', [
      'approveApi',
      'disapproveApi',
    ]),
    ...mapMutations('waitingRoom', [
      'APPROVAL',
      'SET_UNCHECKED',
      'NO_PERMISSION',
      'ADD_WAITING_USER',
      'CHANGE_ROLE_ID'
    ]),
    changeUserRole(user, roleId) {
      this.CHANGE_ROLE_ID({ userId: user.userId, roleId });
    }
  }
}
</script>

<style lang="scss" scoped>
.room-waiting-list-component {
  height: 100%;
  overflow-y: auto;
}
.room-waiting-list {}
.room-waiting-item {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding: 20px;
  background-color: #fff;
  &:first-child {
    border-top: none;
  }
}
.room-waiting-item-form {
  height: 40px;
  display: flex;
  align-items: center;
}
.room-waiting-item-title {
  width: 100px;
  font-size: 12px;
}
.room-waiting-item-value {
  min-width: 0;
  flex: 1;
  display: flex;
  gap: 0 6px;
  font-size: 13px;
  &.success {
    color: $mainColor;
  }
  &.error {
    color: #f05;
  }
}
.room-waiting-item-btn {
  min-width: 0;
  flex: 1;
}
</style>